var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        { name: "no-inherit-class", rawName: "v-no-inherit-class" },
        { name: "no-inherit-style", rawName: "v-no-inherit-style" },
      ],
      staticClass: "tc-tabs",
      class: { "view-container": _vm.isViewContainer },
    },
    [
      _c(
        "div",
        {
          staticClass: "tabs",
          class: [_vm.$vnode.data.staticClass],
          style: [_vm.$vnode.data.staticStyle],
        },
        [
          _c(
            "ul",
            _vm._l(_vm.tabs, function (tab, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: { "is-active": _vm.activeTabId == tab.id },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveTabId(tab.id)
                    },
                  },
                },
                [
                  _c(
                    "a",
                    [
                      _vm._o(
                        _c("node", { attrs: { node: tab.header } }),
                        0,
                        index
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tabs-content",
          class: { "view-container": _vm.isViewContainer },
        },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTabId == tab.id,
                  expression: "activeTabId == tab.id",
                },
              ],
              key: index,
              class: { "view-container": _vm.isViewContainer },
            },
            [_vm._o(_c("node", { attrs: { node: tab.content } }), 1, index)],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }